import { render, staticRenderFns } from "./CommentAnswerHistory.vue?vue&type=template&id=3f498e6f&scoped=true"
import script from "./CommentAnswerHistory.vue?vue&type=script&lang=js"
export * from "./CommentAnswerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f498e6f",
  null
  
)

export default component.exports